import {useState} from "react";
import axios from "axios";

const ChatInput = ({user, clickedUser, getUserMessages, getClickedUsermessages}) => {
    const [textArea, setTextArea] = useState(null)
    const userId = user?.user_id
    const clickUserId = clickedUser?.user_id
    const addMessage = async ()=>{
        const message = {
            timestamp:new Date().toISOString(),
            from_userId: userId,
            to_userId: clickUserId,
            message:textArea
        }
        try{
            await axios.post('https://match-app-backend.herokuapp.com/message',{message})
            getUserMessages()
            getClickedUsermessages()
        }catch (err){
            console.log(err)
        }
    }
    return (
        <div className={'chat-input'} onChange={(e) => setTextArea(e.target.value)}>
            <textarea/>
            <button className="secondary-button" onClick={addMessage}>Submit</button>

        </div>
    )
}
export default ChatInput